import { create } from 'zustand'
import { toast } from 'react-toastify'
import fetcher from '../../../fetcher'

const now = new Date()

// Both dropdowns, the salesperson chips and a saved profit edit all ask for a
// report, and they ask for very different amounts of work — All Time is the
// widest response the page makes. So a slow older response could land last and
// repaint the page under a heading that already said February. Each call stamps
// its request and drops out on resolve if a newer one has started, the same way
// listDealsStore's cascading fetches do.
let _reportsSeq = 0

export const useCrmReportsStore = create((set, get) => ({
    mode: 'ytd',                 // 'month' | 'quarter' | 'ytd' | 'year' | 'all'
    // The period anchor: the month itself, the quarter it falls in, or where a
    // year to date stops. 'year' and 'all' only carry it so switching back
    // restores the period you were on.
    month: now.getMonth(),       // 0-based
    year: now.getFullYear(),
    owner: 'all',
    data: null,
    loading: false,

    fetchReports: async () => {
        const { mode, month, year, owner } = get()
        const mySeq = ++_reportsSeq
        set({ loading: true })
        try {
            const params = new URLSearchParams({ mode, month: String(month), year: String(year) })
            if (owner !== 'all') params.append('owner', owner)
            const res = await fetcher.getCrmReports(params)
            // An older question: a newer request is already out, and loading
            // stays on for it.
            if (mySeq !== _reportsSeq) return
            set({ data: res?.data || null, loading: false })
        } catch (e) {
            if (mySeq !== _reportsSeq) return
            set({ loading: false })
            toast.error('Could not load reports.')
        }
    },

    setControl: (patch) => {
        set(patch)
        get().fetchReports()
    },
}))
